// =========================================================
// * Vue Material Dashboard PRO - v1.4.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";

// Plugins
import App from "./App.vue";
import Chartist from "chartist";

// router setup
// import routes from "./routes/Dashboard-routes";
import routes from "./routes/routes";
import helpers from "./common/helpers_plugin";
import validators from "./common/validators/validators_plugin";
import Toasted from "vue-toasted";
import _ from "lodash";
import Notifications from "./components/NotificationPlugin";
import UserService from "@/common/user.service.js";

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(helpers);
Vue.use(validators);
Vue.use(Toasted, {
  theme: "toasted-primary",
  position: "bottom-center",
  duration: 5000
  // singleton: true,
});
Vue.use(Notifications);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "nav-item active"
});

// check for authentication for pages
router.beforeEach((to, from, next) => {
  let linkRequiresAuth = to.matched.some(record => record.meta.requiresAuth);
  let isUserAuth = UserService.isAuthenticated();

  if (linkRequiresAuth && !isUserAuth) {
    next({ name: "Login" });
  } else {
    next();
  }
});

// global library setup
Vue.prototype.$Chartist = Chartist;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router
});
